import React from 'react'
import './Maintenance.css'
import Header from '../../components/header/Header'
import { ReactComponent as DataCenterRepair } from '../../assets/icons/Maintenance/dataCenter.svg'
import '../../assets/icons/Maintenance/dataCenter.css'
import { useTranslation } from 'react-i18next'
const Maintenance = ({isNetworkError}) => {
    const {t} = useTranslation()  
    return (
        <div className='Maintenance'>
            <Header hasMenu2={true} />

            <div className="MaintenanceWrapper">
                <div className="MaintenanceBlock">
                    <DataCenterRepair/>
                    {
                        isNetworkError == true ?
                        <>
                            <h2>Нестабильное интернет соединение</h2>
                            <p>Пожалуйста, проверьте подключение к сети и перезагрузите страницу.</p>
                            <p>{t("Maintenance.text3")}</p>
                        </>
                        :
                        <>
                            <h2>{t("Maintenance.text1")}</h2>
                            <p>{t("Maintenance.text2")}</p>
                            <p>{t("Maintenance.text3")}</p>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default Maintenance